<template>
  <div ref="drag_handle" :class="classes" :style="style">
    <slot></slot>
  </div>
</template>

<style lang="scss">
  .dnd-grid-box {
    z-index: 2;
    position: absolute;
    box-sizing: border-box;
    transition: transform ease-out 0.3s;

    &:hover {
      cursor: grab;
    }

    &--dragging {
      cursor: grabbing !important;
      transition: none;
      z-index: 3;
    }

    &--placeholder {
      opacity: 0 !important;
      z-index: 1;
      transition: none;
    }
  }
</style>

<script>
  import * as utils from './utils';
  import { List as ContainerList } from './Container';

  export default {
    name: 'DndGridBox',
    props: {
      box_id: {
        required: true,
        type: [String, Number]
      },
      drag_selector: {
        type: String,
        default: '*'
      }
    },
    data() {
      return {
        container: null,
        dragging: false
      };
    },
    computed: {
      style() {
        if (this.container) {
          const pixelPosition = this.container.getPixelPositionById(this.box_id);
          return {
            display: 'block',
            width: utils.BOX_SIZE + 'px',
            height: utils.BOX_SIZE + 'px',
            transform: `translateX(${pixelPosition.x}px) translateY(${pixelPosition.y}px)`
          };
        }

        return {
          display: 'none'
        };
      },

      classes() {
        return {
          'dnd-grid-box': true,
          'dnd-grid-box--dragging': this.dragging
        };
      }
    },

    mounted() {
      this.container = this.findContainer();
      if (!this.container) {
        throw new Error('Can not find container');
      }

      // register component on parent
      this.container.registerBox(this);

      // moving
      this.$drag_handle = this.$el || this.$refs.drag_handle;
      this.$drag_handle.addEventListener('mousedown', evt => {
        if (!utils.matchesSelector(evt.target, this.drag_selector)) {
          return;
        }

        this.dragging = true;
        this.$emit('on-drag-start');
        let mouseX = evt.clientX;
        let mouseY = evt.clientY;

        const handleMouseUp = evt => {
          window.removeEventListener('mouseup', handleMouseUp, true);
          window.removeEventListener('mousemove', handleMouseMove, true);

          this.dragging = false;

          const offset = {
            x: evt.clientX - mouseX,
            y: evt.clientY - mouseY
          };

          this.$emit('on-drag-end', { offset, evt });
          if (Math.abs(offset.x) < 5 && Math.abs(offset.y) < 5) {
            this.$emit('on-click-without-drag', evt);
          }
        };

        const handleMouseMove = evt => {
          var offset = {
            x: evt.clientX - mouseX,
            y: evt.clientY - mouseY
          };
          this.$emit('on-drag-update', { offset });
        };

        window.addEventListener('mouseup', handleMouseUp, true);
        window.addEventListener('mousemove', handleMouseMove, true);
      });
    },

    beforeDestroy() {
      // register component on parent
      if (this.container) {
        this.container.unregisterBox(this);
      }
    },

    methods: {
      findContainer() {
        let current = this;
        while (current.$parent) {
          current = current.$parent;
          if (ContainerList.has(current)) {
            return current;
          }
        }
        return null;
      }
    }
  };
</script>
